// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-aster -> z-modular-aster -> fuze-woodstock
// Generated: 2026-11-03T18:40:19.739Z
// Counts: 8 design, 76 content, 58 slot group, 5 collection binding, 7 section, 4 style

export const designOverrides = {
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "VALUE",
    "value": "#707070",
    "mappedField": null
  },
  "design.SpecialOfferBanner.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_4"
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Work Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Work Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Nunito', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Work Sans', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Accessibility</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_amenities_blurb"
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Amenities</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 40px;\">Designed for Living</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.intro": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Welcome to a world of unmatched luxury and convenience at <span data-type=\"field-token\" data-field=\"property_name\"></span>. Our amenity offerings redefine the standard of modern living, providing an exquisite backdrop to complement your lifestyle.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiessummary.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiessummary.interiorHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_applynow_blurb"
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Apply Now</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_color_4"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_contactus_blurb"
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Contact Us</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "conveniencecallout.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "conveniencecallout.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Convenience All Around</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_floorplans_blurb"
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Floor Plans</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.feature_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_floorplans_blurb"
  },
  "floorplanslist.feature_title": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Spacious Apartment Homes</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.contact_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Contact</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.follow_us_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Follow Us</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.office_hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Office Hours</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.visit_us_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Visit Us</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_gallery_blurb"
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Gallery</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/dog-friendly-apartments-meridian-id::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Discover dog-friendly apartments in Meridian, Idaho. Enjoy pet-friendly living spaces tailored for you and your furry friends.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/dog-friendly-apartments-meridian-id::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Dog-Friendly Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 40px;\">Interactive Map</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "letsconnect.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Have questions about how to start living at your new home? Our dedicated leasing team at <span data-type=\"field-token\" data-field=\"property_name\"></span> is here to assist you.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "letsconnect.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Let's Connect</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_neighborhood_blurb"
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Neighborhood</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Pet-friendly living starts at the front door.</strong> At FUZE Woodstock, your pet has a place in the daily routine—from quick outdoor breaks to cleanup made easier with the on-site pet wash station. After rainy walks, muddy paws, or fresh-air time at nearby leash-free areas around Woodstock, you can rinse, reset, and get back to a home that feels polished without feeling fussy.</p><p>Choose a layout with the space and flow that suits how you live, then make the most of convenient community features designed to simplify apartment life with pets. Review the policy details on this page, then <a class=\"richtext-link\" href=\"/floor-plans\">explore available homes</a> or <a class=\"richtext-link\" href=\"/schedule-a-tour\"><strong>schedule a tour</strong></a> to see how pet-friendly living fits at FUZE.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Pet Policy</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyinfo.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "petpolicyinfo.info": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "petpolicyinfo.restrictions": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_restrictions"
  },
  "petpolicyinfo.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Privacy Policy</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_long_description"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Luxury Apartment Living</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_residentaccess_blurb"
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Resident Access</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.help_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Need Help? Call Us</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.portal_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Resident Portal</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Schedule A Tour</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Sitemap</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "testimonials.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Testimonials</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Thank You</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_virtualtours_blurb"
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Virtual Tour</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Apartment Amenities in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.interiorHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interior Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "better-built-living-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Better Homes in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Community &amp; Apartment Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Gallery</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "meet-the-team-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Meet the local team dedicated to helping you find the perfect home at <span data-type=\"field-token\" data-field=\"property_name\"></span> and guiding you every step of the way.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "meet-the-team-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Your On-Site Team</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "meet-the-team-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Meet The Team</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "meettheteamintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Here to Help You Feel at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.disable_self_guided_tour": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Virtual Apartment Tours in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Virtual Tours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "lifestyleresidenttypes.intro": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>FUZE Woodstock is home to a mix of people: Highway 401 commuters and workers from the city's manufacturing and automotive employers, downsizing retirees, remote workers, and pet owners who want Southside Park close by. With studio, one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> from 317 to 827 sq ft, there's a fit for singles, couples, and roommates alike. Here's who already lives here, and what keeps them here.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "conveniencecallout.background": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "conveniencecallout.cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/neighborhood"
      }
    }
  },
  "floorplanslist.feature_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Choose Your Home"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "flexiblelivingprograms.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a4a-d878-773a-a930-cec812802db9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "FLEX logo"
      }
    }
  },
  "flexiblelivingprograms.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a42-1fb9-70ab-b6d9-28b9225354db.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Obligo logo"
      }
    }
  },
  "flexiblelivingprograms.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a46-8bbe-70aa-b774-4fa553335ff2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Beagle logo with a dog wearing a tie inside an orange square."
      }
    }
  },
  "flexiblelivingprograms.card4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a46-8b62-7369-a1e1-504e1b5e29e7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "RentCafe logo"
      }
    }
  },
  "flexiblelivingprograms.card5_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a4a-247d-7396-b23b-7a6eeab770d3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Guarantors logo."
      }
    }
  },
  "flexiblelivingprograms.card6_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a46-8c3e-7295-89e2-87ef61ff7baa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Pineapple logo"
      }
    }
  },
  "lifestylefeaturerows.row_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cc-330a-7521-85b8-2919277b3711.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of FUZE Woodstock apartment building with signage."
      },
      "eyebrow": {
        "type": "GENERATOR",
        "generatedValue": "Canadian Built & Owned"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Built Better for Everyday Ease"
      },
      "body": {
        "type": "GENERATOR",
        "generatedValue": "<p>FUZE Woodstock is proudly Canadian built and Canadian owned, and it shows in the details you feel every day: extra sound proofing, energy-efficient insulation that helps keep utility costs down, and 9-foot ceilings that make every layout feel open. It's modern construction designed for quieter, more comfortable living just steps from Southside Park.</p>"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "/better-built-living"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Explore Better-Built Living"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_self"
      }
    }
  },
  "lifestylefeaturerows.row_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/flexible-living-program"
      }
    }
  },
  "lifestylefeaturerows.row_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/rewards-programs"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167809/01a14136-f1de-75bb-a27b-b3844ac4cce4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FUZE Woodstock rooftop patio with dining tables and lounge seating overlooking the city at sunset"
      }
    }
  },
  "amenitieslist.apartment_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-c52b-7769-b464-7f4cc89a10e2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living room with sectional sofa and coffee table flowing into a modern kitchen"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open-Concept Living"
      }
    }
  },
  "amenitieslist.apartment_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-0c5d-7750-88ed-b008fbd7f406.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with dark wood cabinets, white subway tile backsplash, stainless steel appliances, and a large window"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Stainless Steel Kitchens"
      }
    }
  },
  "amenitieslist.apartment_slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-2638-74ab-802e-d16f97176d29.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with king-size bed, nightstands, and sliding door to a private balcony"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Spacious Bedrooms"
      }
    }
  },
  "amenitieslist.apartment_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167809/01a14137-2b9b-73dd-997c-88b8d885dd83.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Private balcony with glass railing overlooking the neighbourhood under a clear blue sky"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Private Balconies"
      }
    }
  },
  "amenitieslist.apartment_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-a241-72c0-9242-dd475bc5bc3a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bathroom with white subway tile shower and tub, vanity with white countertop, and wood-style flooring"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Modern Bathrooms"
      }
    }
  },
  "amenitieslist.apartment_slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-52ca-754c-9a5b-2cde8559f278.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "In-suite laundry with full-size stacked washer and dryer and dark storage cabinetry"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "In-Suite Laundry"
      }
    }
  },
  "amenitieslist.community_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167809/01a14136-eef3-76e1-8fb0-4d9fee8f88cb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FUZE Woodstock rooftop patio with dining tables, lounge seating, and BBQ grilling area"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop Patio with BBQ"
      }
    }
  },
  "amenitieslist.community_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-f8cc-73b2-8640-c952a19aff03.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "24-hour fitness centre with treadmills, stair climbers, weight machines, and free weights"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "24-Hour Fitness Centre"
      }
    }
  },
  "amenitieslist.community_slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167809/01a14137-b6d4-74fc-abf8-111adace5f60.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop community kitchen and dining area with bar seating overlooking Woodstock"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Community Kitchen & Dining"
      }
    }
  },
  "amenitieslist.community_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-ed08-73cb-9943-61e3b5b93419.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resident game room with ping-pong and foosball tables beside a seating area and large windows"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Ping-Pong & Foosball Game Room"
      }
    }
  },
  "amenitieslist.community_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cc-156b-70fd-bfd6-edd4f0688f5e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resident lounge with large sectional sofa and modern chairs by floor-to-ceiling windows"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Resident Lounge"
      }
    }
  },
  "amenitieslist.community_slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-81be-723d-9f52-cfb8f12577e3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Lounge with high-top table, modern fireplace, and TV next to the rooftop patio door"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fireplace Lounge"
      }
    }
  },
  "betterbuiltclosing.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167809/01a14136-edfe-7028-b8f5-30615c37da95.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of FUZE Woodstock apartment building, parking lot, and surrounding greenery."
      }
    }
  },
  "betterbuiltconstruction.row_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cc-3a6c-7018-be72-2a5f5db28b3d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Multistory apartment building facade with balconies and orange awnings"
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cc-38f4-72b9-9578-182f37337bc5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FUZE Woodstock entrance at 140 Ferguson Drive with orange canopy, bike racks, and outdoor seating"
      }
    }
  },
  "conveniencecallout.feature_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cc-7646-7060-b449-e0d5248549a2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop lounge area with seating, umbrellas, tables, and a grill."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-c52b-7769-b464-7f4cc89a10e2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Staged living room at FUZE Woodstock with a sectional sofa and coffee table, open to a modern kitchen"
      }
    }
  },
  "floorplanslist.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117ca-eacf-751e-a9ad-3ee3c49fdb40.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room and dining area with white couch, coffee table, and dining table set for two."
      }
    }
  },
  "floorplanslist.feature_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-c52b-7769-b464-7f4cc89a10e2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room with a sectional sofa, coffee table, and open-concept kitchen."
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167809/01a14136-f1de-75bb-a27b-b3844ac4cce4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FUZE Woodstock rooftop patio with dining tables and lounge seating overlooking the city at sunset"
      }
    }
  },
  "lifestyleclosingcta.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cc-57a3-731e-998d-bbc84e4c422f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a modern apartment building exterior with balconies and surrounding green space."
      }
    }
  },
  "lifestylefeaturerows.row_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cc-03dd-7619-afb8-8b55b85dc2ee.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern communal dining area and kitchen with bar seating and large windows."
      },
      "eyebrow": {
        "type": "GENERATOR",
        "generatedValue": "Community"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Where Neighbours Become Friends"
      },
      "body": {
        "type": "GENERATOR",
        "generatedValue": "<p>Our team plans social activities throughout the year, bringing residents together in the community kitchen and lounge, around the ping-pong and foosball tables, and up on the rooftop BBQ deck when the weather warms up. Reach out to the leasing office to find out what's coming up next.</p>"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "/contact-us"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Ask About Events"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_self"
      }
    }
  },
  "lifestyleresidenttypes.type_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "icon": {
        "type": "GENERATOR",
        "generatedValue": "faHouseChimneyUser"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Downsizing Retirees"
      },
      "bullets": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>Elevator access and wheelchair-accessible design</li><li>No yard work, with maintenance on site</li><li>Property manager on site for peace of mind</li><li>Extra sound proofing keeps home quiet</li></ul>"
      }
    }
  },
  "lifestyleresidenttypes.type_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "icon": {
        "type": "GENERATOR",
        "generatedValue": "faUsers"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Couples & Roommates"
      },
      "bullets": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>Butler II offers two bedrooms, two baths</li><li>Up to 827 sq ft of open-concept space</li><li>In-suite washer and dryer, no shared laundry</li><li>Community kitchen for hosting bigger gatherings</li></ul>"
      }
    }
  },
  "lifestyleresidenttypes.type_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "icon": {
        "type": "GENERATOR",
        "generatedValue": "faLaptopFile"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Remote Workers"
      },
      "bullets": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>Built-in desk nooks in select kitchens</li><li>High-speed internet access in every suite</li><li>Lounge high-top tables by big windows</li><li>Luxer package lockers handle deliveries securely</li></ul>"
      }
    }
  },
  "lifestyleresidenttypes.type_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "icon": {
        "type": "GENERATOR",
        "generatedValue": "faTree"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor Enthusiasts"
      },
      "bullets": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>Southside Park trails and gardens nearby</li><li>Indoor bike storage for year-round riders</li><li>Rooftop patio with seasonal BBQ deck</li><li>Sports fields and skate park close by</li></ul>"
      }
    }
  },
  "lifestyleresidenttypes.type_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "icon": {
        "type": "GENERATOR",
        "generatedValue": "faBriefcase"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Highway 401 Commuters"
      },
      "bullets": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>About three minutes to Highway 401</li><li>Reserved parking waiting after long shifts</li><li>EV charging stations on site</li><li>VIA Rail downtown for Toronto and London</li></ul>"
      }
    }
  },
  "lifestyleresidenttypes.type_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "icon": {
        "type": "GENERATOR",
        "generatedValue": "faPaw"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pet Parents"
      },
      "bullets": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>Paw-friendly, as permitted by Ontario law</li><li>Pet wash station keeps muddy paws outside</li><li>On-site pet play area for daily zoomies</li><li>Southside Park walks just steps away</li></ul>"
      }
    }
  },
  "meettheteamcontactcta.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cc-57a3-731e-998d-bbc84e4c422f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a modern apartment building exterior with balconies and surrounding green space."
      }
    }
  },
  "meettheteammembers.member_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "photo": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a16047-4bc8-754c-83fe-703065fe564a.webp"
      },
      "photo_alt": {
        "type": "VALUE",
        "customValue": "A smiling woman with long, brown hair stands in front of a wood-paneled wall."
      },
      "bio": {
        "type": "VALUE",
        "customValue": "<p>Justiana is happy to be working as a Leasing Professional here at FUZE! She has been working in the industry for a few years now. In her free time, she enjoys playing rugby and spending time with family and friends. Justiana’s favourite amenity is the Rooftop Patio!</p>"
      },
      "name": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "Justiana M."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Leasing Professional"
      }
    }
  },
  "meettheteammembers.member_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "bio": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "meettheteammembers.member_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "bio": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-12e5-7179-893f-983ef95d32fe.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Southside Park in Woodstock, Ontario, a large green park near FUZE Woodstock"
      }
    }
  },
  "photoslider.slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cc-330a-7521-85b8-2919277b3711.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of FUZE Woodstock apartment building with signage."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Welcome to FUZE Woodstock"
      }
    }
  },
  "photoslider.slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cc-2050-705a-8d01-b3e397e2d534.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room with a gray sofa, coffee table, and view of the kitchen and balcony."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open-Concept Living"
      }
    }
  },
  "photoslider.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-8e82-7528-a0d1-523b621a0d83.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a large island with pendant lighting."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Stainless Steel Kitchens"
      }
    }
  },
  "photoslider.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-ed08-73cb-9943-61e3b5b93419.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Ping pong table and foosball table in a modern lounge with seating area and large windows."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Ping-Pong & Foosball Lounge"
      }
    }
  },
  "photoslider.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-f8cc-73b2-8640-c952a19aff03.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "State-of-the-art fitness center with treadmills, stair climbers, weight machines, and free weights."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "24-Hour Fitness Centre"
      }
    }
  },
  "photoslider.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-2638-74ab-802e-d16f97176d29.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bedroom with a king-size bed, nightstands, and a balcony view."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Bedrooms with Balcony Access"
      }
    }
  },
  "rewardsprograms.program1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cc-03dd-7619-afb8-8b55b85dc2ee.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Communal dining area and resident kitchen with bar seating at FUZE Woodstock"
      }
    }
  },
  "rewardsprograms.program2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-795f-77dd-9b55-61bcb7959b2c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resident lounge at FUZE Woodstock with high-top work tables and stools by large windows"
      }
    }
  },
  "rewardsprograms.program3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167809/01a14136-f1de-75bb-a27b-b3844ac4cce4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FUZE Woodstock rooftop patio with dining and lounge seating at sunset"
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cc-2050-705a-8d01-b3e397e2d534.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Furnished living room at FUZE Woodstock with gray sofa and coffee table, open to the kitchen and private balcony"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "photoslider.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      0,
      1,
      2,
      3,
      7,
      11,
      10,
      9
    ],
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      22,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52
    ],
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": 12,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": 12,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "testimonials.background": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_4aef277ecce6b95dd94e095e",
      "ec_645972e6223619dd0388ea8d",
      "ec_98689857fabb025bd7b57f13",
      "ec_59d402350ce6da0ca974a493",
      "ec_76ecb22ecee7f2027447a5b6",
      "ec_99077a89a1e5991e29b4645c",
      "ec_17e59ff1ce1dc839c8779fbf",
      "ec_55b315e8faa8091c3857d609",
      "ec_addce47e3cf37a5a76a4936c",
      "ec_a8f9026cf11717e2c73b56e2",
      "ec_5271f85ee1ba2fae88edf9b5",
      "ec_fb1471099cb9fb36977b5070",
      "ec_41049236f8d5c7c375037a65",
      "ec_080f83305a906cefe941e032",
      "ec_c7814498b2c383f3f4b46cfd",
      "ec_56274181436e3e0f781bd4bb",
      "ec_032a575d4d7b9a230970e35b",
      "ec_121b15bdaf1c7b90a160f29c",
      "ec_d0e289a19cbdd411e479c888",
      "ec_f6fe56ca1e7da0b77ea6baa8",
      "ec_cfdf40bfc09ea37e33f991f4",
      "ec_7ea487420221fa47d7bd2e9e",
      "ec_b74b8ff9b597fad021e3a700",
      "ec_0b64e63ee148852a69653927",
      "ec_b50f4b6a258cdc6709894638",
      "ec_f84fdac9d4476192fece17e0",
      "ec_ad018898996f1925379b298c",
      "ec_80e0eb2eeb40daa3e68cf3e1",
      "ec_ecf01ff93d2e3405e1efc7ca",
      "ec_d33aa4768b63287c04780987",
      "ec_48335c99b88ced0ffdbce92d",
      "ec_f8620827e575df41dd197afc",
      "ec_26e5aa212f3ede2063f9f716",
      "ec_33a78d3b652b685bac520d9b",
      "ec_fd08a30a35efade9fd950398",
      "ec_da1469aa5c8746b70e568c84",
      "ec_e8b30049c195f5262bc4b0ba",
      "ec_8c61e589371021bc2de7c728",
      "ec_2d05f20810ae127e67e1b46d",
      "ec_d1b87bf5df044b0fadfca718",
      "ec_058565b43c6c4befdd23058d",
      "ec_47b4d2487a5e8316c4ea0503",
      "ec_6ccc91ee9a2c628083739c12",
      "ec_de2a6a311324f2dcebd9d896",
      "ec_795e94bd3b2f6bb71ad8e007",
      "ec_3c64592ab635e94b21e81996",
      "ec_ad6c58f0faf8664e0c6fadde",
      "ec_1fd3caaaf9ea834955614741",
      "ec_e08110ba51be2ed9e684872d",
      "ec_b38eb566f24b6a2066a649ea",
      "ec_74e413293454ea63843b7798",
      "ec_6402c3886648337951c7fc3d",
      "ec_4abb848dbc3b3bf066fdaf89",
      "ec_25921f34515ae67a9a27a475",
      "ec_86afebfdb0f9f42f440d0dba",
      "ec_65fb24e2cd99aeb955a5dea5",
      "ec_2454ff322ef2f78cf015ee8c",
      "ec_b16666c81cc33b78d7157834",
      "ec_027ab28aa589ea629b95511f",
      "ec_1a5561709498624891de3d7a",
      "ec_2d139c678c8f8b05706f11b1",
      "ec_262575512b2d5ec66ae7aeeb",
      "ec_65c11ca07ba75e591e24238e",
      "ec_829913ab775c8534f2f238fc",
      "ec_563426f37f5fb0c325004656",
      "ec_4744c8514b6159612777705a",
      "ec_5815be86535b4c37ccf60b67",
      "ec_b8e76f20be4d6e9663b78a53",
      "ec_cd262d247aa78b91776d9a39",
      "ec_9e32d93189b37131d60d36a4",
      "ec_0df3384a73029ccbcee84ab1",
      "ec_9c82bdda2cab0bcb3254d7c9",
      "ec_b3064c7a05302ff98776f8c1",
      "ec_69927593b383d3b6a1e5f217",
      "ec_40bdf39b849476e4692b520a",
      "ec_101a2c3687753bf38ce00563",
      "ec_9a2c548c2c384c24f17c013a",
      "ec_bc98ce6052565dd143ad695b",
      "ec_37c39c785bb229530a2c12b9",
      "ec_0e46cf284e17370a440cf7cd",
      "ec_3fc065c4e01fa1ad4474a57a",
      "ec_5ccba15e79ea498589a8e41e"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "virtualtourembed.tours": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_48fea4d4-7bec-4f03-8649-04bef411c079",
      "custom_3d161e4a-e08d-4299-b6d9-48388154e1fd",
      "custom_776d2ab5-5c20-4dfc-aa24-eb9bb91bfda2",
      "custom_f6542097-5542-4c8c-8339-5cd02274db39",
      "custom_998447a1-3980-4e44-9742-b385129fa302",
      "custom_2f5f7d5b-aaf1-4eb7-98fd-45268f4a9e72",
      "custom_68d10c18-102d-4951-9b6b-5a70d03980e9"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "funnel-fenix-chatbot",
      "blockId": "funnel-fenix-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {
  "_section.BetterBuiltConstruction": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.block:engrain-sitemap": {
    "properties": {
      "paddingTop": "50px",
      "paddingRight": "150px",
      "paddingBottom": "150px",
      "paddingLeft": "150px",
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "backgroundColor": "#fefefe"
    }
  },
  "_section.LifestyleFeatureRows": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  }
};
